import { Image, Modal } from "@mantine/core";
import { getAssetUrl } from "@utils/getAssetUrl";
import classes from "./ReservationPopup.module.scss";

interface ReservationPopupProps {
	opened: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

export default function ReservationPopup({
	opened,
	onClose,
	onConfirm,
}: ReservationPopupProps) {
	return (
		<Modal.Root
			opened={opened}
			onClose={onClose}
			centered
			zIndex={400}
			classNames={{ inner: classes.modalInner }}
		>
			<Modal.Overlay opacity={0.35} />
			<Modal.Content p="0" bg="white">
				<Modal.Header bg="white" py="0" mih="11.34vw">
					<Modal.CloseButton />
				</Modal.Header>
				<Modal.Body px="7.22vw" pb="7.58vw">
					<Image
						src={getAssetUrl("/images/ec-campaign/product-page/modal-text.png")}
						w="100%"
					/>
					<Image
						src={getAssetUrl("/images/ec-campaign/product-page/modal-btn.png")}
						w="100%"
						mt="2.58vw"
						onClick={onConfirm}
					/>
				</Modal.Body>
			</Modal.Content>
		</Modal.Root>
	);
}
